import { signal } from '@preact/signals';

export const commentCarouselSlot = signal<HTMLElement | null>(null);
export const apCarouselSlot = signal<HTMLElement | null>(null);
